import { FileActionButton } from "../file-action/file-action-controls";
import React, { useRef } from "react";
import { Dialog } from "primereact/dialog";
import { DataTable } from "primereact/datatable";
import { Column } from "primereact/column";
import { InputText } from "primereact/inputtext";
import { Order } from "./OrderSearchById";
import { dailyMapBucket, dailyMapDelayReason, dailyMapStatus, distinctDailyOrders } from "../../utils/daily-map";

type Props = {
  visible: boolean;
  orders: Order[];
  globalFilter: string;
  setGlobalFilter: (value: string) => void;
  onHide: () => void;
  title: string;
};

export default function OrdersDialog({ visible, orders, globalFilter, setGlobalFilter, onHide, title }: Props) {
  const dtRef = useRef<DataTable<Order[]>>(null);

  const uniqueOrders = distinctDailyOrders(orders).map(order => ({ ...order, statusText: dailyMapStatus(order), delayReason: dailyMapDelayReason(order) }));

  const exportToExcel = () => {
    if (!dtRef.current) return;
    dtRef.current.exportCSV({ selectionOnly: false });
  };

  const dialogHeader = (
    <div style={{ display: "flex", justifyContent: "space-between", alignItems: "center" }}>
      <span>{title}</span>
      <FileActionButton action="export"
        icon="pi pi-file-excel"
        label="Export to Excel"
        onClick={exportToExcel}
        className="p-button-success"
        style={{ height: "2rem", marginRight: "0.5rem" }}
        disabled={uniqueOrders.length === 0} 
      />
    </div>
  );

  return (
    <Dialog
      header={dialogHeader}
      visible={visible}
      style={{ width: "70vw" }}
       onHide={() => {
    setGlobalFilter(""); 
    onHide();            
  }}
      
    >
      {uniqueOrders.length > 0 && (
        <div style={{ marginBottom: "10px" }}>
          <span className="p-input-icon-left" style={{ width: "100%" }}>
            <i className="pi pi-search" />
            <InputText
  value={globalFilter}
  onChange={(e) => setGlobalFilter(e.target.value)}
  placeholder="Search by any field"
  style={{
    width: "30%",
    border: "1px solid #ced4da", 
    borderRadius: "4px",          
  }}
/>

          </span>
        </div>
      )}

      {uniqueOrders.length === 0 ? (
        <p>No orders found.</p>
      ) : (
        <DataTable
          ref={dtRef}
          value={uniqueOrders}
          responsiveLayout="scroll"
          stripedRows
          showGridlines
          globalFilter={globalFilter}
          scrollable
          scrollHeight="400px"
          paginator
          rows={10}
          rowsPerPageOptions={[5, 10, 20, 50]}
          sortMode="multiple" 
        >
          <Column field="orderID" header="Order ID" sortable />
          <Column field="userName" header="Customer Name" sortable />
          <Column field="userNumber" header="Customer No." sortable />
          <Column field="driverName" header="Executive Name" sortable />
          <Column field="driverNumber" header="Executive No." sortable />
          <Column
            header="Status"
            body={(order) => {
              const statusColor =
                dailyMapBucket(order) === "delivered"
                  ? "#16a34a"
                  : dailyMapBucket(order) === "cancelled"
                  ? "#dc2626"
                  : dailyMapBucket(order) === "delayed" ? "#d97706" : dailyMapBucket(order) === "unknown" ? "#6b7280" : "#3b82f6";
              return <span style={{ color: statusColor, fontWeight: 600 }}>{order.statusText}</span>;
            }}
            field="statusText"
            sortable
          />
          <Column field="delayReason" header="Delay reason" sortable />
          <Column field="delayRemarks" header="Remarks" body={(order: Order) => order.delayRemarks || "—"} sortable />
        </DataTable>
      )}
    </Dialog>
  );
}

